// Helper function to get the appropriate redirect URL
const getRedirectUrl = () => {
    // Check if we're running on localhost
    if (typeof window !== 'undefined' && window.location.hostname === 'localhost') {
        return window.location.origin;
    }
    // Otherwise use the environment variable or domain
    return process.env.REACT_APP_OAUTH_REDIRECT_SIGNIN || 'https://' + process.env.REACT_APP_DOMAIN;
};

// Helper function to get Google Client ID based on environment
const getGoogleClientId = () => {
    const domain = process.env.REACT_APP_DOMAIN;
    if (domain === 'development.kandilove.com' || domain === 'localhost:3000') {
        return '611794718266-fqf7bjvnoc81n3dqn3tubd0i964dj4ng.apps.googleusercontent.com';
    } else if (domain === 'kandi.kandilove.com' || domain === 'kandilove.com') {
        return '811417272779-cu25ao91cjoopgrhpil7koej2amf55r6.apps.googleusercontent.com';
    }
    // Default to development
    return '611794718266-fqf7bjvnoc81n3dqn3tubd0i964dj4ng.apps.googleusercontent.com';
};

export const googleClientId = getGoogleClientId();

export const awsAmplifyConfig = {
    Auth: {
        Cognito: {
            userPoolId: process.env.REACT_APP_USER_POOL_ID!,
            userPoolClientId: process.env.REACT_APP_USER_CLIENT_ID!,
            loginWith: {
                oauth: {
                    domain: process.env.REACT_APP_DOMAIN?.replace(/\./g, '-') + '.auth.us-west-2.amazoncognito.com',
                    scopes: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
                    redirectSignIn: [getRedirectUrl()],
                    redirectSignOut: [getRedirectUrl()],
                    responseType: 'code' as const,
                    providers: ['Google' as const]
                }
            }
        }
    }
};

export const awsDevelopmentAmplifyConfig = {
    Auth: {
        Cognito: {
            userPoolId: process.env.REACT_APP_USER_POOL_ID!,
            userPoolClientId: process.env.REACT_APP_USER_CLIENT_ID!,
            loginWith: {
                oauth: {
                    domain: process.env.REACT_APP_DOMAIN?.replace(/\./g, '-') + '.auth.us-west-2.amazoncognito.com',
                    scopes: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
                    redirectSignIn: [getRedirectUrl()],
                    redirectSignOut: [getRedirectUrl()],
                    responseType: 'code' as const,
                    providers: ['Google' as const]
                }
            }
        }
    }
};
